import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://kbgrqfw6uj.execute-api.eu-central-1.amazonaws.com/beta/order'
});

export default instance;